import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  tile: {
    elevation: 2,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1,
    shadowRadius: 5,
    width: "24vmin",
    height: "7vmin",
    borderRadius: 2,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "$option_card",
    margin: 10,
  },
  tileSelected: {
    backgroundColor: "$selected_option",
  },
  text: {
    margin: 5,
    textAlign: "center",
    fontSize: "$tile_text_size",
    fontFamily: "$tile_text_style",
    color: "$option_text",
  },
  textSelected: {
    color: "$survey_card",
  },
});
